module.exports = __webpack_public_path__ + "img/perks.d7e99f1b.png";